'use client';

import { useParams } from 'next/navigation';
import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { RollingPage } from 'app/(main)/rollings/[rollingId]/RollingPage';
import { useInAppState } from '@/contexts/InAppProvider';

export default function Page() {
  const params = useParams();
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  const rollingId = params?.rollingId ?? '';

  return <RollingPage isApp={isApp} rollingId={Number(rollingId)} />;
}
